import React from 'react';
import './tableCOA.css';

const TableCOA = ({ group }) => {
  const { rkoderek, data, jmldebet, jmlkredit, balance } = group;

  return (
    <div className="tableCOAWrapper table-responsive mb-5">
      <table className="table table-bordered table-hover table-sm">
        <thead className="table-secondary">
          {/* Baris judul akun */}
          <tr>
            <th colSpan={2}>{rkoderek}</th>
            <th colSpan={4}>{data[0]?.account?.name5 || '-'}</th>
          </tr>

          {/* Baris judul kolom */}
          <tr>
            <th>DATE</th>
            <th>REFERENCE</th>
            <th>DESCRIPTION</th>
            <th>PO</th>
            <th>DEBET</th>
            <th>CREDIT</th>
          </tr>
        </thead>

        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>
                {new Date(item.transaction?.rtanggal).toLocaleDateString(
                  'id-ID'
                )}
              </td>
              <td>{item.transaction?.rreferensi}</td>
              <td>{item.transaction?.rterang}</td>
              <td>{item.rkodepo}</td>
              <td className="right-align">
                {Number(item.rdebet).toLocaleString('id-ID')}
              </td>
              <td className="right-align">
                {Number(item.rkredit).toLocaleString('id-ID')}
              </td>
            </tr>
          ))}

          {/* Total dan Balance */}
          <tr>
            <td colSpan={3}></td>
            <th>Total</th>
            <td className="right-align">{jmldebet.toLocaleString('id-ID')}</td>
            <td className="right-align">{jmlkredit.toLocaleString('id-ID')}</td>
          </tr>
          <tr>
            <td colSpan={3}></td>
            <th className="font-bold">Balance</th>
            <td colSpan={2} className="right-align">
              {balance.toLocaleString('id-ID')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TableCOA;
